import { NavLink, useLocation } from 'react-router-dom';
import { Home, Car, PlusCircle, Coins, User } from 'lucide-react';
import { BackupAlertBanner } from './BackupAlertBanner';
import { RattachementAlert } from './RattachementAnomalies';

const MOBILE_NAV = [
    { to: '/dashboard', label: 'Accueil', icon: Home },
    { to: '/mes-dossiers', label: 'Dossiers', icon: Car },
    { to: '/calculator', label: 'Nouveau', icon: PlusCircle, accent: true },
    { to: '/commissions', label: 'Commissions', icon: Coins },
    { to: '/profil', label: 'Profil', icon: User },
];

export default function MobileLayout({ children }) {
    const location = useLocation();
    const isCalculator = location.pathname.startsWith('/calculator');

    return (
        <div className="min-h-screen bg-[#F5F7FA] flex flex-col" data-testid="mobile-layout">
            <main className="flex-1 pb-[calc(4.5rem+env(safe-area-inset-bottom))] overflow-y-auto">
                <BackupAlertBanner /><RattachementAlert />
                {children}
            </main>

            {!isCalculator && (
                <nav className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-gray-200 pb-[env(safe-area-inset-bottom)]" data-testid="mobile-bottom-nav">
                    <div className="flex items-center justify-around h-[4.5rem] max-w-lg mx-auto px-2">
                        {MOBILE_NAV.map(item => {
                            const Icon = item.icon;
                            const isActive = item.to === '/calculator'
                                ? false
                                : location.pathname === item.to || (item.to === '/dashboard' && location.pathname === '/');
                            return (
                                <NavLink
                                    key={item.to}
                                    to={item.to}
                                    className="flex flex-col items-center justify-center gap-0.5 min-w-[3.5rem] py-1 rounded-xl transition-colors active:scale-95"
                                    data-testid={`mobile-nav-${item.to.slice(1) || 'home'}`}
                                >
                                    {item.accent ? (
                                        <div className="w-12 h-12 rounded-2xl bg-[#6366F1] flex items-center justify-center shadow-lg shadow-indigo-200 -mt-4">
                                            <Icon className="w-6 h-6 text-white" strokeWidth={2} />
                                        </div>
                                    ) : (
                                        <Icon
                                            className={`w-6 h-6 transition-colors ${isActive ? 'text-[#6366F1]' : 'text-gray-400'}`}
                                            strokeWidth={isActive ? 2 : 1.5}
                                        />
                                    )}
                                    <span className={`text-[10px] font-medium ${item.accent ? 'text-[#6366F1] -mt-0.5' : isActive ? 'text-[#6366F1]' : 'text-gray-400'}`}>
                                        {item.label}
                                    </span>
                                </NavLink>
                            );
                        })}
                    </div>
                </nav>
            )}
        </div>
    );
}
